import EditIcon from "@/assets/SVG/editIcon";
import TrashIcon from "@/assets/SVG/trashIcon";
import { Box, IconButton, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { removeEquipment } from "../../../api/group";
import CustomTable from "../../customTable/CustomTable";
import SelectionsTableDrug from "../drug/selectionsTableDrug";

export default function TableEquipment({
  rowData,
  setRowData,
  create,
  date,
  date1,
  tableArea,
  notGroup,
  setEquipmentIdFromUpdate,
  setMode,
  pageable,
  setPageable,
  totalElements,
}) {
  const [selection, setSelection] = useState([]);

  const [colDefs, colDefs1] = useMemo(
    () => [
      [
        {
          headerName: "ردیف",
          headerCheckboxSelection: true,
          checkboxSelection: true,
          valueGetter: (params) => params.node.rowIndex + 1,
          width: 100,
        },

        {
          field: "name",
          headerName: "اسم تجهیزات",
          width: 200,
        },
        {
          field: "equipmentType",
          headerName: "نوع تجهیز",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography fontFamily="Vazirmatn" sx={{ lineHeight: "unset" }}>
                  {x.data?.equipmentType === "INFRASTRUCTURE"
                    ? "زیرساختی"
                    : "مصرفی"}
                </Typography>
              </Box>
            );
          },
        },
        {
          field: "healthStatus",
          headerName: "وضعیت",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography
                  fontFamily="Vazirmatn"
                  sx={{
                    lineHeight: "unset",
                    padding: "0 12px",
                    background:
                      x.data?.healthStatus === "VALID"
                        ? "var(--emr-green-back)"
                        : x.data?.healthStatus === "DAMAGED"
                          ? "var(--emr-red-back)"
                          : "var(--emr-yellow-back)",
                    color:
                      x.data?.healthStatus === "VALID"
                        ? "var(--emr-green)"
                        : x.data?.healthStatus === "DAMAGED"
                          ? "var(--emr-red)"
                          : "var(--emr-yellow)",
                    borderRadius: "8px",
                  }}
                >
                  {x.data?.healthStatus === "VALID"
                    ? "سالم"
                    : x.data?.healthStatus === "DAMAGED"
                      ? "خراب"
                      : "در حال تعمیر"}
                </Typography>
              </Box>
            );
          },
        },
        {
          field: "expireAt",
          headerName: "تاریخ خرید",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                {create ? (
                  <Typography
                    fontFamily="Vazirmatn"
                    sx={{ lineHeight: "unset" }}
                  >
                    {`${date?.day} / ${date?.month} / ${date?.year} `}
                  </Typography>
                ) : (
                  <Typography
                    fontFamily="Vazirmatn"
                    sx={{ lineHeight: "unset" }}
                  >
                    {x.data?.buyAt?.split("T", 2)[0]}
                  </Typography>
                )}
              </Box>
            );
          },
        },
        {
          field: "expireAt",
          headerName: "تاریخ مصرف",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                {create ? (
                  <Typography fontFamily="Vazirmatn">
                    {`${date1?.day} / ${date1?.month} / ${date1?.year} `}
                  </Typography>
                ) : (
                  <Typography fontFamily="Vazirmatn">
                    {x.data?.usedAt?.split("T", 2)[0]}
                  </Typography>
                )}
              </Box>
            );
          },
        },
        {
          field: "producer",
          headerName: "شرکت سازنده",
          width: 200,
        },
        {
          field: "available",
          headerName: "تعداد ",
          width: 200,
        },
        {
          field: "location",
          headerName: "محل انبار",
          width: 200,
        },
        {
          field: "rowNo",
          headerName: "شماره ردیف",
          width: 200,
        },
        {
          field: "shelfNo",
          headerName: "شماره قفسه",
          width: 200,
        },
        {
          field: "description",
          headerName: "توضیحات",
          width: 200,
        },
        {
          field: "name",
          headerName: "عملیات",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                gap="10px"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <IconButton
                  onClick={() => {
                    setEquipmentIdFromUpdate(x.data);
                    setMode("new");
                  }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    removeEquipment(x.data?.id)
                      .then(() => {
                        setRowData((z) => {
                          let array = [...z];
                          array = array.filter((item) => item.id !== x.data.id);
                          return array;
                        });
                      })
                      .catch(() => {});
                  }}
                >
                  <TrashIcon />
                </IconButton>
              </Box>
            );
          },
        },
      ],
      [
        {
          headerName: "ردیف",
          valueGetter: (params) => params.node.rowIndex + 1,
          width: 100,
        },
        {
          field: "name",
          headerName: "اسم تجهیزات",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography fontFamily="Vazirmatn">
                  {x.data?.equipmentInfo?.name}
                </Typography>
              </Box>
            );
          },
        },
        {
          field: "healthStatus",
          headerName: "وضعیت",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography fontFamily="Vazirmatn">
                  {x.data?.equipmentInfo?.healthStatus === "VALID"
                    ? "سالم"
                    : x.data?.equipmentInfo?.healthStatus === "DAMAGED"
                      ? "خراب"
                      : "در حال تعمیر"}
                </Typography>
              </Box>
            );
          },
        },
        {
          field: "name",
          headerName: "شرکت سازنده",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography fontFamily="Vazirmatn">
                  {x.data?.equipmentInfo?.producer}
                </Typography>
              </Box>
            );
          },
        },
        {
          headerName: "اعتبار گارانتی",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                key={`guaranteeExpireAt_${x.id}`}
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                {create ? (
                  <Typography fontFamily="Vazirmatn">
                    {`${date1?.day} / ${date1?.month} / ${date1?.year} `}
                  </Typography>
                ) : (
                  <Typography fontFamily="Vazirmatn">
                    {x.data?.equipmentInfo?.guaranteeExpireAt?.split("T", 2)[0]}
                  </Typography>
                )}
              </Box>
            );
          },
        },
        {
          headerName: "توضیحات",
          width: 200,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                key={`desc_${x.id}`}
                display="flex"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <Typography fontFamily="Vazirmatn">
                  {x.data?.equipmentInfo?.description}
                </Typography>
              </Box>
            );
          },
        },
      ],
    ],
    [],
  );

  return (
    <>
      <CustomTable
        totalElements={totalElements}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        currentPage={pageable.pageIndex}
        selection={selection}
        setSelection={setSelection}
        rowData={rowData}
        columns={tableArea ? colDefs1 : colDefs}
      />

      {selection?.length > 0 && (
        <SelectionsTableDrug
          notGroup={notGroup}
          equipment
          selection={selection}
        />
      )}
    </>
  );
}
